import { LicenseExpiringModalActionTypes } from '../actions/license-expiring-modal';
import { USER_LOGOUT } from '../actions/types';

const licenseExpiringModalInitialState = {
  showModal: false,
  daysRemaining: null
};

function licenseExpiringModalReducer(state = licenseExpiringModalInitialState, action) {
  switch (action.type) {
    case LicenseExpiringModalActionTypes.SHOW_LICENSE_EXPIRING_MODAL:
      return {
        showModal: true,
        daysRemaining: action.payload.daysRemaining
      };
    case LicenseExpiringModalActionTypes.HIDE_LICENSE_EXPIRING_MODAL:
      return licenseExpiringModalInitialState;
    case USER_LOGOUT:
      return licenseExpiringModalInitialState;
    default:
      return state;
  }
}

export default licenseExpiringModalReducer;
